import { gql } from '@apollo/client';

export const GET_CUSTOMER_INFO_BY_PHONE = gql`
   query getCustomerInfoByPhone($username: String!) {
      customerInfo(phone: $username) {
        name
        skype
        birthday
        ask
      }   
    }`;


export const GET_USER_BY_PHONE_IF_AUTHENTICATED = gql`
query getUserByPhone($username: String!) {
    userUsername(username: $username) {
        firstName
        lastName
        email
        id
        isStaff
        customer {
          id
          middleName
          sex
          balance
          ask
          skype
          birthday
          adres {
            edges {
              node {
                id
                index
                address
                city
                region
                country
              }
            }
          }
        }
      }
}
`

export const GET_ALL_ORDERS = gql`
query($cursor: String, $username: String!) { 
    allOrders(first: 100, after: $cursor, customer_User_Username: $username) {
      edges {
        node {
          id
          source
          payUntil
          createdAt
          pairVisit
          ticketSet {
            edges {
              node {
                id
                orders {
                  edges {
                  	node {
                      id
                      payUntil
                      event {
                          id
                          videoCallUrl
                          accessToken
                          accessTokenClient
                          roomId
                          roomPassword
                          startDate
                          endDate
                      }
                      payment {
                        status
                      }
                      service {
                        meetingType
                      }
                      source
                    }
                  }
                }
                description {
                  visit
                }
              }  
            }
          }
          service {
            id
            meetingType
          }
          meetingStatus
          specialist {
            id
            photo
            photoResized
            name
            specialisation
            skype
            pairDetails
            slug
            onlineCount
            offlineCount
          }
          event {
            id
            address {
              id
              address
              town
              district
              parking
              shema
              tfm
            }
            startDate
            endDate
            videoCallUrl
            accessToken
            accessTokenClient
            roomId
            roomPassword
          }
          payment {
            id
            status
            amount
            alfa {
              id
              payUrl 
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
}`;

export const UPDATE_PASSWORD = gql`
mutation
  UpdateUser(
    $username: String!, 
    $password: String!,
  ) {
    updateUser(
      username: $username,
      userData: {
        password: $password
      }  
    ) {
        user{
          id
        }
      }
  }
`;

export const UPDATE_USER = gql`
mutation
  UpdateUser(
    $username: String!, 
    $firstName: String!,
    $lastName: String!,
    $email: String!
  ) {
    updateUser(
      username: $username,
      userData: {
        firstName: $firstName,
        lastName: $lastName,
        email: $email
      }  
    ) {
        user{
          id
          firstName
          lastName
          email
        }
      }
  }
`;

export const UPDATE_CUSTOMER = gql`
mutation UpdateCustomer(
    $username: String!,
    $skype: String!,
    $birthday: String!,
    $middleName: String = "",
    $sex: String = "M",
    $ask: String
  ) {
      updateCustomer(
        username: $username,
        customerData: {
            skype: $skype,
            middleName: $middleName,
            birthday: $birthday,
            sex: $sex,
            ask: $ask
        }
      ){
        customer {
          id
          skype
          middleName
          sex
          ask
        }
      }
  }`;


export const GET_CUSTOMER_BUYS = gql`
  query getBuys($customer_User_Username: String!) {
    allBuys(customer_User_Username: $customer_User_Username){
      edges{
        node{
            id
            pk
            source
            createdAt
            delivery {
              status
              tracking
              extendDeliveryStatus
              system
            }
            items {
              edges {
                node {
                  id
                  item{
                    id
                    name
                    price
                    photo
                    photoResized
                    url
                    descriptionShort
                  }
                  quantity
                }
              }
            }
            payment{
              status
              amount
              alfa {
                payUrl
              }
              yandex {
                payUrl
              }
            }
        }
      }
    }
  }
`


export const GET_CUSTOMER_PURCHASES = gql`
  query getPurchases($customer_User_Username: String!) {
    allPurchases(customer_User_Username: $customer_User_Username){
      edges{
        node{
            id
            pk
            source
            createdAt
            digital {
                id
                name
                price
                photo
                photoResized
                link
                webinarLink
                descriptionShort
                url
                files{
                  edges{
                    node{
                      file
                      urlIframe
                      title
                      subtitle
                      detail
                      isActive
                    }
                  }
                }
            }
            payment{
              system
              status
              amount
              alfa {
                payUrl
              }
              yandex {
                payUrl
              }
            }
        }
      }
    }
  }
`

export const UPDATE_CUSTOMER_BALANCE = gql`
     mutation updateCustomerBalance(
        $code: String!,
  		$phone: String!
    ) {
      updateCustomerBalance(
        username: $phone,
        promocode: $code
      ){
    error,
    customer {
        id
        balance
    } 
  }
}`

export const GET_CUSTOMER_PRICE = gql`
    query getCustomerPrice($phone: String!, $service:ID!, $visits:Int!) {
        customerPrice(phone: $phone, service: $service, visits: $visits) {
            price
        }
    }
`

export const GET_DIGITAL_BY_NAME = gql`
query getAllDigitals($name: String!) {
    allDigital(name: $name) {
        edges{
          node{
            id
            price
            name
            link
            url
            soonActive
            photo
            photoResized
            tags {
              edges {
                node {
                  title
                }
              }
            } 
            createdAt
            points
            files{
              edges{
                node{
                  file
                }
              }
            }
            descriptionShort
            descriptionFull
            isActive
          }
        }
    }
}`
